import { Button, ButtonGroup, Dialog, Fade, Grid, Typography, Zoom } from "@mui/material";
import i18n from "../reducers/i18n";
import SortableDragAndDrop from "./SortableDragAndDrop/SortableDragAndDrop";
import NotificationTypesFilter from "./SortableDragAndDrop/Filters/NotificationTypesFilter";
import React, { useEffect, useState } from "react";
import AreaPoolFilter from "./SortableDragAndDrop/Filters/AreaPoolFilter";
import UsersFilter from "./SortableDragAndDrop/Filters/UsersFilter";
import { connect } from "react-redux";
import { Add } from "@mui/icons-material";
import { getalluser } from "../actions/user";
import Skeliton from "./SortableDragAndDrop/Skeliton";
import { Link } from "react-router-dom";

import { ReactComponent as KompactSvg } from "../assets/Compact.svg";
import { ReactComponent as DetailsSvg } from "../assets/Details.svg";

import { ReactComponent as FokusSvg } from "../assets/Focus.svg";
import { ReactComponent as StandardSvg } from "../assets/Standard.svg";

import { ReactComponent as HeaderLogo } from "../assets/AufgabenPlanung.svg";
import {
  getallaclusers,
} from "../actions/user";
import PersistedMultiSelect from "../components/PersistedMultiSelect";
import { getItem } from "../utils/DataProtection";
import PersistedMitarbeiterSelect from "./PersistedMitarbeiterSelect";
import { getallsitesareaeqs,getsitesareaeqs2 } from "../actions/objects";


export default connect(
  ({ users, subscribedSites, aclusers, userProfile, subscribedEquipmentpools }) => ({
    users, subscribedSites, subscribedEquipmentpools,
    userProfile,
    aclusers
  }),
  {
    getalluser,
    getallaclusers,
    getsitesareaeqs2,
    getallsitesareaeqs
  }
)((props) => {

  const { users } = props;

  // header filters

  const [FilterNotificationTypes, setFilterNotificationTypes] = useState([
    "all",
  ]);

  const [areaPoolFilterValue, setAreaPoolFilterValue] = useState([]);

  const [userFilter, setUserFilter] = useState([
    
  ]);

  const [isFocused, setIsFocused] = useState(false); // switch between standard and fokused view

  const [viewMode, setViewMode] = useState("d");   // d = Detail view , c = Compact view

  const [showSkeliton, setShowSkeliton] = useState(true);

  const [_users, set_users] = React.useState([]);

  const enterBrowserFullscreen = async () => {
    const root = document.documentElement;

    if (document.fullscreenElement || !root?.requestFullscreen) {
      return;
    }

    try {
      await root.requestFullscreen();
    } catch (error) {
      // Ignore rejected fullscreen requests and keep dialog mode working.
    }
  };

  const exitBrowserFullscreen = async () => {
    if (!document.fullscreenElement || !document.exitFullscreen) {
      return;
    }

    try {
      await document.exitFullscreen();
    } catch (error) {
      // Ignore exit failures.
    }
  };

  const openFocusMode = async () => {
    setIsFocused(true);
    await enterBrowserFullscreen();
  };

  const closeFocusMode = async () => {
    setIsFocused(false);
    await exitBrowserFullscreen();
  };

  const toggleFocusMode = async () => {
    if (isFocused) {
      await closeFocusMode();
      return;
    }

    await openFocusMode();
  };

  useEffect(() => {
    props.getalluser();

    props.getallsitesareaeqs("", "ALL_SAE");
    props.getsitesareaeqs2("", "SAE2");

    setTimeout(() => {
      setShowSkeliton(false);
    }, 2000)
    props.getallaclusers("ACL_USERS");
  }, []);

  useEffect(() => {
    if (!isFocused) return undefined;

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsFocused(false);
      }
    };

    const handleFullscreenChange = () => {
      if (!document.fullscreenElement) {
        setIsFocused(false);
      }
    };

    window.addEventListener("keydown", handleEscape);
    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      window.removeEventListener("keydown", handleEscape);
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [isFocused]);

  useEffect(() => {
    if ((users.length && props.aclusers?.length)) {
      const temp2 = [];
      for (const usr of users) {
        let userid = props.aclusers.length
          ? props.aclusers.filter(
            (user) => user.user.usernodeid === usr.user.nodeid
          )[0]?.user.userid : "";

        if (userid !== undefined) {
          temp2.push({
            ...usr,
          });
        }
      }

      set_users(temp2);




      const persisted = getItem("persisted_content_configurations");
      const userInfo = JSON.parse(getItem("userinfo"));
      const activeConfig = persisted ? JSON.parse(persisted) : userInfo?.contentconfigurations;
      let userNodeId = JSON.parse(getItem("usernodeid"));
      const filterList = activeConfig?.filterSettings?.[userNodeId] || [];

      const savedMitarbeiter = filterList.find(
        (f) => f.section === "AufgabenPlanung" && f.type === "mitarbeiter"
      );

      if (savedMitarbeiter?.options?.length > 0) {
        const isAll = savedMitarbeiter.options.some((o) => o.name === "all_users");
        let initialValues;

        if (isAll) {
          initialValues = ["all", ..._users.map((e) => `${e?.user?.nodeid}`)];
        } else {
          initialValues = savedMitarbeiter.options.map((o) => `${o.nodeId}`);
        }

        if (props?.userProfile?.user?.nodeid) {
          if (!initialValues.includes(props.userProfile.user.nodeid)) {
            initialValues.push(props.userProfile.user.nodeid);
          }
        }
        setUserFilter(initialValues);
      }
      else {
        // set current user as default selected in user filter
        const currentUser = temp2.find(
          (user) =>
            user.user.nodeid === props?.userProfile?.user?.nodeid
        );
        if (currentUser) {
          setUserFilter([currentUser?.user?.nodeid]);
        }
      }

    }
  }, [users, props.aclusers]);


  // setting default value (first site) of area pool filters 
  // useEffect(() => {
  //   if (Object.keys(props.subscribedSites).length) {
  //     setAreaPoolFilterValue("s==>" + Object.values(props.subscribedSites)[0].nodeid);
  //   }
  // }, [props.subscribedSites]);


  return (
    <>
      {/* Dialog for fokus view */}
      <Dialog
        fullScreen
        fullWidth
        open={isFocused}
        onClose={closeFocusMode}
        TransitionComponent={Fade}
        transitionDuration={1000}
        PaperProps={{
          sx: {
            margin: 0,
            maxWidth: "100%",
            width: "100%",
            height: "100%",
            borderRadius: 0,
            boxShadow: "none",
          },
        }}
      >
        <div
          id="content-container"
          style={{
            backgroundColor: "white",
            padding: "28px 24px",
            minHeight: "100vh",
            height: "100%",
            marginBottom: 0,
            boxShadow: "none",
            borderRadius: 0,
            overflow: "auto",
          }}

        >
          {
            showSkeliton ?

              <Skeliton /> : <><div style={{ display: "flex", alignItems: "center" }}>

                <HeaderLogo />

                <Typography variant="h1" sx={{ marginLeft: "20px" }}>
                  {i18n().menu_Instandhaltung_submenu2}
                </Typography>

                <Link
                  className="btn-submit"
                  to={"/create-notification"}
                  style={{ marginLeft: "2%" }}
                  state={{
                    notification: "",
                    equip: "",
                    equip_pool: "",
                    date: "",
                    time: "",
                    pageType: "create",
                    from: "aufgabe"
                  }}
                >
                  <Button variant="contained" startIcon={<Add />}>
                    {" "}
                    Neu{" "}
                  </Button>
                </Link>

                <div className="dnd_viewmode">
                  <ButtonGroup
                    variant="outlined"
                  >
                    <Button
                      startIcon={
                        <KompactSvg
                          backgroundColor={viewMode === "c" ? "#FFFFFF" : "#0F3F51"}
                          className={viewMode === "c" ? "dnd_groupButton_active_c" : "dnd_groupButton_c"}
                        />
                      }
                      onClick={() => setViewMode("c")}
                      variant={viewMode === "c" ? "contained" : "outlined"}
                      color="primary"
                    >kompakt</Button>

                    <Button
                      startIcon={
                        <DetailsSvg
                          backgroundColor={viewMode === "d" ? "#FFFFFF" : "#0F3F51"}
                          className={viewMode === "d" ? "dnd_groupButton_active_d" : "dnd_groupButton_d"}
                        />
                      }
                      onClick={() => setViewMode("d")}
                      variant={viewMode === "d" ? "contained" : "outlined"}
                      color="primary"
                    >Details</Button>

                  </ButtonGroup>

                  <Button onClick={toggleFocusMode} variant="outlined" sx={{ marginLeft: 4 }} startIcon={isFocused ? <StandardSvg /> : <FokusSvg />}> {isFocused ? "Standard" : "Fokus"} </Button>
                </div>



              </div>

                <br />

                <Grid container spacing={3} style={{ marginTop: 0 }}>
                  <Grid
                    item
                    xs={12}
                    sx={{ paddingTop: "15px !important", display: "flex" }}
                  >
                    {/* <Grid xs={4}>
                      <AreaPoolFilter
                        areaPoolFilterValue={areaPoolFilterValue}
                        setAreaPoolFilterValue={setAreaPoolFilterValue}
                       
                      />
                    </Grid> */}

                    <Grid xs={6}>
                      <NotificationTypesFilter
                        setFilterNotificationTypes={setFilterNotificationTypes}
                        FilterNotificationTypes={FilterNotificationTypes}
                        isFocused={isFocused}
                      />
                    </Grid>
                    <Grid xs={0.2}></Grid>

                    <Grid xs={5.8}>
                      {/* <UsersFilter
                        userFilter={userFilter}
                        setUserFilter={setUserFilter}
                        users={_users}
                        aclusers={props.aclusers}
                        isFocused={isFocused}
                      /> */}
                      <Grid item style={{ marginLeft: isFocused ? "0px" : "20px" }} className={isFocused ? "dnd_Filters_dialog" : "dnd_Filters"}>
                        <PersistedMitarbeiterSelect
                          userId={JSON.parse(getItem("userid"))}
                          userNodeId={JSON.parse(getItem("usernodeid"))} // <-- important!
                          userInfo={JSON.parse(getItem("userinfo"))}
                          employees={_users}
                          userFilter={userFilter}
                          setUserFilter={setUserFilter}
                          className="my-custom-style"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <br></br>
                <Grid container spacing={3} style={{ marginTop: 0 }}>
                  <Grid item xs={12} sx={{ paddingTop: "15px !important" }}>
                    <SortableDragAndDrop
                      areaPoolFilter={areaPoolFilterValue}
                      notificationTypesFilter={FilterNotificationTypes}
                      userFilter={userFilter}
                      showEquipment={viewMode === "d"}
                      isFocused={isFocused}
                      _users={_users}
                    />
                  </Grid>
                </Grid>
              </>}
        </div>
      </Dialog>

      <div
        id="content-container"
        className="bxShadow"
        style={{
          backgroundColor: "white",
          height: 500,
          padding: "28px 24px",
          height: "auto",
          marginBottom: "10%",
        }}
      >
        {
          showSkeliton ?

            <Skeliton /> : <><div style={{ display: "flex", alignItems: "center" }}>

              <Typography variant="h1">
                {i18n().menu_Instandhaltung_submenu2}
              </Typography>

              <Link
                className="btn-submit"
                to={"/create-notification"}
                style={{ marginLeft: "2%" }}
                state={{
                  notification: "",
                  equip: "",
                  equip_pool: "",
                  date: "",
                  time: "",
                  pageType: "create",
                  from: "aufgabe"
                }}
              >
                <Button variant="contained" startIcon={<Add />}>
                  {" "}
                  Neu{" "}
                </Button>
              </Link>

              <div className="dnd_viewmode">
                <ButtonGroup
                  variant="outlined"
                >
                  <Button
                    startIcon={
                      <KompactSvg
                        backgroundColor={viewMode === "c" ? "#FFFFFF" : "#0F3F51"}
                        className={viewMode === "c" ? "dnd_groupButton_active_c" : "dnd_groupButton_c"}
                      />
                    }
                    onClick={() => setViewMode("c")}
                    variant={viewMode === "c" ? "contained" : "outlined"}
                    color="primary"
                  >kompakt</Button>

                  <Button
                    startIcon={
                      <DetailsSvg
                        backgroundColor={viewMode === "d" ? "#FFFFFF" : "#0F3F51"}
                        className={viewMode === "d" ? "dnd_groupButton_active_d" : "dnd_groupButton_d"}
                      />
                    }
                    onClick={() => setViewMode("d")}
                    variant={viewMode === "d" ? "contained" : "outlined"}
                    color="primary"
                  >Details</Button>

                </ButtonGroup>

                <Button onClick={toggleFocusMode} variant="outlined" sx={{ marginLeft: 4 }} startIcon={isFocused ? <StandardSvg /> : <FokusSvg />}> {isFocused ? "Standard" : "Fokus"} </Button>
              </div>



            </div>

              <br />

              <Grid container spacing={3} style={{ marginTop: 0 }}>
                <Grid
                  item
                  xs={12}
                  sx={{ paddingTop: "15px !important", display: "flex" }}
                >
                  {/* <AreaPoolFilter
                    areaPoolFilterValue={areaPoolFilterValue}
                    setAreaPoolFilterValue={setAreaPoolFilterValue}
                    isFocused={isFocused}
                  /> */}


                  <PersistedMultiSelect
                    userId={JSON.parse(getItem("userid"))}
                    userNodeId={JSON.parse(getItem("usernodeid"))} // <-- important!
                    userInfo={JSON.parse(getItem("userinfo"))}
                    setUserInfoState={(updated) => {
                      // update local state if needed
                    }}
                    section="AufgabenPlanung"
                    i18nLabel="Maschinenpark / Abschnitt"
                    value={areaPoolFilterValue}
                    onChange={(e) => setAreaPoolFilterValue(e.target.value)}
                    subscribedSites={props.subscribedSites}
                    subscribedEquipmentpools={props.subscribedEquipmentpools}
                    className="dnd-area-filter"
                  />


                  <NotificationTypesFilter
                    setFilterNotificationTypes={setFilterNotificationTypes}
                    FilterNotificationTypes={FilterNotificationTypes}
                    isFocused={isFocused}
                  />

                  {/* <UsersFilter
                    userFilter={userFilter}
                    setUserFilter={setUserFilter}
                    users={_users}
                    isFocused={isFocused}
                  /> */}
                  <Grid item style={{ marginLeft: isFocused ? "0px" : "20px" }} className={isFocused ? "dnd_Filters_dialog" : "dnd_Filters"}>
                    <PersistedMitarbeiterSelect
                      userId={JSON.parse(getItem("userid"))}
                      userNodeId={JSON.parse(getItem("usernodeid"))} // <-- important!
                      userInfo={JSON.parse(getItem("userinfo"))}
                      employees={_users}
                      userFilter={userFilter}
                      setUserFilter={setUserFilter}
                      className="my-custom-style"
                    />
                  </Grid>

                </Grid>
              </Grid>
              <br></br>
              <Grid container spacing={3} style={{ marginTop: 0 }}>
                <Grid item xs={12} sx={{ paddingTop: "15px !important" }}>
                  <SortableDragAndDrop
                    areaPoolFilter={areaPoolFilterValue}
                    notificationTypesFilter={FilterNotificationTypes}
                    userFilter={userFilter}
                    showEquipment={viewMode === "d"}
                    _users={_users}
                  />
                </Grid>
              </Grid>
            </>}
      </div>
    </>
  );
});
